import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 12.8.",
  "description": "",
  "published": "2011-08-12T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-12-8/swizec/2205"],
  "categories": "Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/20110813-084033.jpg",
        "alt": "20110813-084033.jpg"
      }}></img></p>
    <p>{`Today I learned that replacing a keyboard on a Unibody MacBookPro is a very expensive affair. Spilled some water on it last night and even though everything was working the right shift key was stuck and I eventually locked myself out of the computer completely because I couldn't type the password.`}</p>
    <p>{`Took the computer apart but wasn't able to get to the last dropplets of water. Taking a laptop in such condition to the Apple Store turns out to be a pretty fruitless idea as well. Was told my best and only bet was just to replace the whole thing with a new one. Going to the mac repair shop was a bit better. They only wanted 550 dollars to replace the whole upper part of the laptop. I couldn't just buy a new keyboard either because the holes don't fit the US keyboard layout ... enter key is different.`}</p>
    <p>{`On the other hand I discovered a wonderful new method of writing today. Bought a wireless apple keyboard that can attach to either my laptop, iPad or iPhone. Connecting it to the smallest possible device is both fun and ... well kind of weird. But having an iPhone in my pocket and typing without seeing what I'm doing is really brilliant for creative writing. In fact I'm writing this very post by having the iPad in a completely different place that I can't even see and when it's done I'll just edit.`}</p>
    <p>{`This really quiets the inner editor so I can write in peace :) And I can totally write pretty much wherever now, there is no cumbersome laptop or anything ^^`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      